import { CustomReadOnlyFieldProps } from './types/CustomInputsTypes';

const CustomReadTextArea: React.FC<CustomReadOnlyFieldProps> = ({ data, className }) => {
  const formattedValue = data.value.replace(/\n\n/g, '<br/><br/>');

  return (
    <div
      className={`flex flex-col flex-1 w-full bg-white border-b border-gray-100 gap-2 p-2 ${className}`}
    >
      {data?.label && <h3 className="font-semibold text-gray-800 text-[16px]">{data.label}</h3>}
      <div
        className="font-normal text-gray-500 text-sm"
        dangerouslySetInnerHTML={{ __html: formattedValue }}
      />
    </div>
  );
};

export default CustomReadTextArea;
